<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="用户ID" prop="userId">
                <a-input v-model="queryParam.userId" placeholder="请输入用户ID" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="收益" prop="revenue">
                <a-input v-model="queryParam.revenue" placeholder="请输入收益" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="获取收益目标用户ID" prop="targetId">
                  <a-input v-model="queryParam.targetId" placeholder="请输入获取收益目标用户ID" allow-clear/>
                </a-form-item>
              </a-col>
            </template> -->

            <a-col :md="8" :sm="24">
              <a-form-item label="订单编号" prop="objId">
                <a-input v-model="queryParam.objId" placeholder="订单编号" @pressEnter="handleQuery" allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="下单人昵称/手机号" prop="nickname">
                <a-input
                  v-model="queryParam.nickname"
                  placeholder="请输入下单人昵称/手机号"
                  @pressEnter="handleQuery"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="收益人昵称/手机号" prop="tNickname">
                <a-input
                  v-model="queryParam.tNickname"
                  placeholder="请输入收益人昵称/手机号"
                  @pressEnter="handleQuery"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <template>
              <a-col :md="8" :sm="24">
                <a-form-item label="商品名称" prop="name">
                  <a-input v-model="queryParam.name" placeholder="商品名称" @pressEnter="handleQuery" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:distributionRecord:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:distributionRecord:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:distributionRecord:remove']">
          <a-icon type="delete" />删除
        </a-button> -->
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:distributionRecord:export']">
          <a-icon type="download" />导出
        </a-button>
        <!-- <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        /> -->
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1500, y: 350 }"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ (current - 1) * size + index + 1 }}
        </span>
        <span slot="tMobile" slot-scope="text, record">
          <a-card hoverable style="width: 133px">
            <template>
              <img
                v-viewer
                style="width: 48px; height: 48px; margin-top: 5px; margin-right: 5px"
                v-if="record.avatar"
                :src="record.avatar"
                preview="图片"
              />
            </template>
            <a-card-meta :title="record.nickname">
              <template #description>{{ record.tMobile }}</template>
            </a-card-meta>
          </a-card>
        </span>

        <span slot="name" slot-scope="text, record">
          <a-card hoverable style="width: 133px">
            <template>
              <img
                v-viewer
                style="width: 48px; height: 48px; margin-top: 5px; margin-right: 5px"
                v-if="record.picture"
                :src="record.picture"
                preview="图片"
              />
            </template>
            <a-card-meta :title="record.name">
              <template #description>{{ record.money }}</template>
            </a-card-meta>
          </a-card>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record, index">
          <a-divider type="vertical" v-hasPermi="['user:distributionRecord:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:distributionRecord:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['user:distributionRecord:remove']" />
          <a @click="handleDelete(record, index)" v-hasPermi="['user:distributionRecord:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDistributionRecord, listDistributionRecord, delDistributionRecord } from '@/api/user/distributionRecord'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'DistributionRecord',
  components: {
    CreateForm,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      //索引indexs
      indexs: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        nickname: null,
        tNickname: null,
        revenue: null,
        targetId: null,
        name: null,
        objId: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        // {
        //   title: '主键',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '订单号',
          dataIndex: 'objId',

          align: 'center',
          width: 50,
          fixed: 'left',
          width: 85,
        },
        // {
        //   title: '用户ID',
        //   dataIndex: 'userId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '收益人',
          dataIndex: 'tMobile',
          scopedSlots: { customRender: 'tMobile' },
          align: 'center',
          width: 140,
        },
        {
          title: '佣金',
          dataIndex: 'revenue',
          ellipsis: true,
          align: 'center',
          width: 100,
        },
        {
          title: '分销类型',
          dataIndex: 'inviteType',
          ellipsis: true,
          align: 'center',
          width: 130,
          customRender(f) {
            if (f == 1) {
              return '直推'
            } else if (f == 2) {
              return '间推'
            }
          },
        },
        // 0-待支付，1-已支付，2-已发货，3-已完成  4-已售后  5-待评价 -1 取消订单
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          width: 130,
          customRender(f) {
            if (f == 0) {
              return '待支付'
            } else if (f == 1) {
              return '已支付'
            } else if (f == 2) {
              return '已发货'
            } else if (f == 3) {
              return '已完成'
            } else if (f == 4) {
              return '已售后'
            } else if (f == 5) {
              return '待评价'
            } else if (f == -1) {
              return '取消订单'
            }
          },
        },

        {
          title: '下单人',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center',

        },
        // {
        //   title: '获取收益目标用户ID',
        //   dataIndex: 'targetId',
        //   ellipsis: true,
        //   align: 'center'
        // },

        {
          title: '时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },

          align: 'center',
          width: 100,
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '商品信息',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          ellipsis: true,
          align: 'center',
          width: 160,
        },
        // ,
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   width: '18%',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询分销收益记录列表 */
    getList() {
      this.loading = true
      pageDistributionRecord(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        userId: undefined,
        revenue: undefined,
        targetId: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()

    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      // 列表顶部删除indexs
      if (this.selectedRowKeys.length) {
        const indexList = this.selectedRowKeys.map((item) => {
          return this.list.findIndex((i) => i.id === item)
        })
        this.indexs = indexList
          .filter((item) => item !== -1)
          .map((ind) => {
            return (this.current - 1) * this.size + ind + 1
          })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row, index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if (row.id) {
            data.push({ id: row.id })
          } else {
            that.ids.map((id) => data.push({ id: id }))
          }
          return delDistributionRecord(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          // that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'user/distributionRecord/export',
            {
              ...that.queryParam,
            },
            `分销收益记录_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
